import icon from './info-filled.svg';

const FormHint = ({ children, showIcon = false }) => <p className="hint">
  {showIcon === true && <img src={icon} alt="hint" className="hint__icon" aria-hidden="true"/>}
  {children}
</p>;

export default FormHint;
